// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: apps/client/src/world/objects/*.ts
import * as m0 from './objects/board';
import * as m1 from './objects/bridge';
import * as m2 from './objects/building';
import * as m3 from './objects/decor';
import * as m4 from './objects/dropbox';
import * as m5 from './objects/house';
import * as m6 from './objects/mailbox';
import * as m7 from './objects/rock';
import * as m8 from './objects/tree';
export const objectViewModules = [m0, m1, m2, m3, m4, m5, m6, m7, m8] as const;
